var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';
var InputGroup = forwardRef(function (_a, ref) {
    var label = _a.label, helpText = _a.helpText, error = _a.error, containerClassName = _a.containerClassName, labelClassName = _a.labelClassName, inputClassName = _a.inputClassName, helpTextClassName = _a.helpTextClassName, errorClassName = _a.errorClassName, _b = _a.labelWidth, labelWidth = _b === void 0 ? 'w-1/3' : _b, className = _a.className, children = _a.children, props = __rest(_a, ["label", "helpText", "error", "containerClassName", "labelClassName", "inputClassName", "helpTextClassName", "errorClassName", "labelWidth", "className", "children"]);
    var inputContainerWidth = labelWidth === 'w-1/3' ? 'w-2/3' : 'w-1/2';
    return (_jsxs("div", __assign({ className: cn('space-y-2', containerClassName) }, { children: [_jsxs("div", __assign({ className: "flex items-center gap-4" }, { children: [label && (_jsx(Label, __assign({ htmlFor: props.id, className: cn('text-sm font-medium flex-shrink-0', labelWidth, labelClassName) }, { children: label }))), _jsx("div", __assign({ className: "flex-1 ".concat(inputContainerWidth) }, { children: children ? (children) : (_jsx(Input, __assign({ ref: ref, className: cn('w-full py-1 h-auto h-9', error && 'border-red-500 focus:ring-red-500', inputClassName, className) }, props))) }))] })), (helpText || error) && (_jsxs("div", __assign({ className: cn('flex', label ? 'pl-[calc(33.333333%+1rem)]' : '') }, { children: [helpText && !error && (_jsx("p", __assign({ className: cn('text-sm text-gray-500', helpTextClassName) }, { children: helpText }))), error && (_jsx("p", __assign({ className: cn('text-sm text-red-500', errorClassName) }, { children: error })))] })))] })));
});
InputGroup.displayName = 'InputGroup';
export default InputGroup;
